import React, { useRef, useEffect } from "react";
import classNames from "classnames";
import { motion, AnimatePresence } from "framer-motion";
import { Portal } from "./Portal";
import { Backdrop } from "./Backdrop";
export const Modal = ({ isOpen, className, children, onClose }) => {
    const modalContentRef = useRef(null);
    const handleClickOuter = (event) => {
        const target = event.target;
        if (target.contains(modalContentRef.current)) {
            onClose();
        }
    };
    const handleKeyDown = (event) => {
        if (event.code === "Escape") {
            onClose();
        }
    };
    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return (React.createElement(AnimatePresence, null, isOpen ? (React.createElement(Portal, null,
        React.createElement(Backdrop, null),
        React.createElement(motion.div, { className: classNames({
                "modal fade show": true,
                [className]: typeof className !== "undefined",
            }), style: { display: "block" }, onClick: handleClickOuter, initial: { y: -50, opacity: 0 }, animate: { y: 0, opacity: 1 }, exit: { y: -50, opacity: 0 }, transition: { ease: "linear" } },
            React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                React.createElement("div", { className: "modal-content", ref: modalContentRef },
                    React.createElement("button", { className: "btn-close", onClick: () => {
                            onClose();
                        } },
                        React.createElement("i", { className: "icon-x" })),
                    children))))) : null));
};
